import { Component, OnInit } from '@angular/core';
import { ClientesService } from 'src/app/services/clientes.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-alertas',
  templateUrl: './alertas.component.html',
  styleUrls: ['./alertas.component.scss']
})
export class AlertasComponent implements OnInit {
  respuestaGet:any;
  grupos:any;
  datosCliente:any;

  constructor(private _getClientes:ClientesService, private _getData:LoginService,) { }

  ngOnInit(): void {
    this.getDataCliente();
    this.getReporteGrupos30();
  }

  
  getDataCliente(){
    this._getData.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
        
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  getReporteGrupos30(){
    this._getClientes.reporteGrupos30().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.grupos = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  } 
}
